document.addEventListener("DOMContentLoaded", () => {
    const nameInput = document.querySelector('input[name="name"]'); // Поле "ФИО ответственного"
    const cityInput = document.querySelector('input[name="mail"][type="city"]'); // Поле "Город"

    // Функция для предотвращения ввода цифр
    const restrictNumericInput = (event) => {
        const invalidChars = /[0-9]/; // Регулярное выражение для цифр
        if (invalidChars.test(event.key)) {
            event.preventDefault(); // Блокировка ввода
        }
    };

    // Удаление цифр при вставке текста
    const removeNumbers = (inputElement) => {
        inputElement.value = inputElement.value.replace(/[0-9]/g, ""); // Удаляет цифры
    };

    // Привязка обработчиков событий
    if (nameInput) {
        nameInput.addEventListener("keypress", restrictNumericInput);
        nameInput.addEventListener("input", () => removeNumbers(nameInput));
    }
    if (cityInput) {
        cityInput.addEventListener("keypress", restrictNumericInput);
        cityInput.addEventListener("input", () => removeNumbers(cityInput));
    }
});